export default __webpack_public_path__ + "static/media/nextjs-black-logo.2e296d8e.svg";